<template>
  <div class="btn-select">
    <el-popover v-if="btnList.length > 1" popper-class="btnpopperclass" :placement="placement" :width="width" :visible-arrow="false" v-model="visible">
      <div class="container">
        <div class="item" v-for="(item, index) in btnList" :key="index" @click="clickBtn(item)">
          <el-button class="zwx-button zwx-button-text-32" type="text">{{ item.name }}</el-button>
        </div>
      </div>
      <el-button slot="reference" class="zwx-button zwx-button-32" style="margin:0px 10px;padding: 0px 12px !important;" type="text" @click="clickBtnContainer">
        <div style="display:flex;align-items:center;">
          <span style="color:#0037c7;margin-right:5px;">{{ btnName }}</span>
          <div :style="visible ? 'transform:rotate(180deg);transform-origin: 50% 50%;transition: all .5s ease 0s;' : 'transition: all .5s ease 0s;'">
            <i class="iconfont icon-launch_1" style="font-size:16px;color:#0037c7;"></i>
          </div>
        </div>
      </el-button>
    </el-popover>
    <div v-else class="item" v-for="(item, index) in btnList" :key="index" @click="clickBtn(item)">
      <el-button class="zwx-button zwx-button-32">{{ item.name }}</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BtnSelect',
  props: {
    width: {
      type: Number,
      default: 75,
    },
    placement: {
      type: String,
      default: 'top',
    },
    btnName: {
      type: String,
      default: '',
    },
    btnList: {
      type: Array,
      default: () => [],
    },
  },
  components: {},
  data() {
    return {
      api: this.$store.state.api,
      baseUrl: this.$store.state.baseUrl,
      visible: false,
    }
  },
  async mounted() {},
  activated() {},
  methods: {
    clickBtn(item) {
      this.visible = false
      this.$emit('clickBtn', item.clickEvent)
    },
    clickBtnContainer() {
      this.$emit('clickBtnContainer')
    },
  },
}
</script>

<style lang="less" scoped>
.btn-select {
  // width: 100px;
  /deep/.zwx-button + .zwx-button {
    margin-left: 0px !important;
  }
}
/deep/button.el-button.zwx-button.zwx-button-text-28.el-button--text {
  margin-left: 0px !important;
}
</style>
<style lang="less">
.el-popover.btnpopperclass {
  min-width: 70px !important;
  padding: 0px !important;
  .zwx-button-32.el-button--primary,
  .zwx-button-icontext-32.el-button--primary,
  .zwx-button-32 {
    padding: 0px 12px !important;
  }
  .container {
    display: flex;
    flex-direction: column;
    align-items: center;
    .item {
      width: 100%;
      height: 36px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      button.el-button.zwx-button.zwx-button-text-32.el-button--text {
        color: #000000 !important;
      }
      &:hover {
        background: #ecf9ff;
        button.el-button.zwx-button.zwx-button-text-32.el-button--text {
          color: #217dea !important;
        }
      }
    }
  }
  .el-popper[x-placement^='top'] {
    margin-bottom: 0px !important;
  }
}
</style>
